export default __webpack_public_path__ + "87fb939458e3deb4bf200371514abd17.svg";